import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-modify',
  templateUrl: './modify.component.html',
  styleUrls: ['./modify.component.scss'],
 
})
export class ModifyComponent implements OnInit {
  mark: '';
  modeInfo={
    category:'',
    usmStaff:'',
    mode:'',
    typeOfParticipant:'',
    techCategory:'',
  }
  constructor(
    public dialogRef: MatDialogRef<ModifyComponent>,
    private dialog: MatDialog,
    private toast: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(data.mark){
      this.mark = data.mark;
    }
    if(data){
      this.modeInfo = data;
    }
   }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  select(){
    if (!this.modeInfo.category && !this.modeInfo.mode && !this.modeInfo.typeOfParticipant && !this.modeInfo.usmStaff && !this.modeInfo.techCategory) {
      this.toast.error("Invalid info");
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '30%';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm?';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        this.dialogRef.close({...this.modeInfo, mark: (this.mark && this.mark > 0)?this.mark: null})
      }
    })
  }


}
